<template>
  <v-layout align-center column style="margin-top: 100px;">
    <p class="Section-Title">Pertanyaan Seputar Pendanaan</p>
    <div v-bind:style="{'width': widthComponent}">
      <v-divider></v-divider>
       <pertanyaan-content v-for="(data,i) in questions" :data="data" :key="i"/>
     

    </div>
  </v-layout>
</template>
<script>
import PertanyaanContent from './PertanyaanContent.vue';

export default {
    components: { PertanyaanContent },

  data(){
    return {
      size: 0,
      widthComponent: 0,
      questions: [
        {
        title: "Apakah melakukan pendanaan di Dompet Kilat aman?",
        detail: ` Aman. Dompet Kilat diawasi dan memiliki izin operasional dari OJK. Dompet Kilat juga tersertifikasi ISO:27001 tentang sistem manajemen keamanan informasi.`,
        visible: true
      },
       {
        title: "Apa itu ekosistem supply chain financing?",
        detail: `Dompet Kilat hanya memberikan pinjaman pada mitra usaha yang sudah tergabung dalam kelompok binaan yang memiliki rantai pasokan yang jelas dalam industrinya.`,
        visible: false
      },
      {
        title: "Siapa saja yang dapat menjadi pendana di Dompet Kilat?",
        detail: `Siapa saja yang memiliki KTP Indonesia.`,
        visible: false
      },
      {
        title: "Apakah berinvestasi di Dompet Kilat pasti untung?",
        detail: `Tidak. Semua jenis investasi memiliki risikonya masing-masing.`,
        visible: false
      },
      {
        title: "Bagaimana kalau peminjam gagal bayar?",
        detail: `Dompet Kilat memilih dengan ketat mitra usaha yang dibiayai melalui ekosistem dan menjaminnya dengan asuransi. Namun, risiko tetap ada.`,
        visible: false
      },
      ]
    }
  },
    mounted(){
    this.onResize()
  },
  destroyed(){
    window.removeEventListener('resize', this.resizeEventHandler)
  },
  created(){
    this.resizeEventHandler()
    window.addEventListener('resize',this.resizeEventHandler)
  },
  methods:{
    resizeEventHandler(){
      this.size = `${window.innerWidth/2}px`
      this.widthComponent = `${window.innerWidth/1.5}px`
    
    },
    onResize(){
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };

    }
  }
};
</script>
<style scoped>
.Section-Title {
  /* width: 402px; */
  height: 30px;
  flex-grow: 0;
  margin: 0px auto 49px;
  font-family: Sora;
  font-size: 28px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}


</style>
